<template>
	<div>
		<loader-component v-if="loading" :loader-message="'Loading Trade History...'" :style="'height: 45vh'"></loader-component>

		<div class="mt-3">
			<div v-if="isEmpty(tradeHistory)">
				<h5 class="tx-color-01 mg-b-5 tx-center">Empty.</h5>
				<p class="tx-color-03 tx-13 tx-center">No Trade History available at the moment.</p>
			</div>
			<div v-else>
				<trade-history-data-component :trade-history="tradeHistory" />
			</div>
		</div>
	</div>
</template>

<script>
import { requests } from '../../../../mixins';
import { mapGetters } from 'vuex';

export default {
	mixins: [requests],
	mounted() {
		this.fetchData();
	},
	data() {
		return {
			loading: true,
			tradeHistory: [],
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			company: 'company',
		}),
	},
	methods: {
		fetchTradeHistory(external_client_id) {
			return axios.get('/api/trade/history', {
				params: {
					external_client_id,
				},
			});
		},
		fetchData() {
			const { external_client_id } = this.company;

			axios
				.all([this.fetchTradeHistory(external_client_id)])
				.then(
					axios.spread((tradeHistoryResponse) => {
						this.tradeHistory = tradeHistoryResponse.data.data.trade_history;
					})
				)
				.finally(() => (this.loading = false));
		},
	},
};
</script>

<style>
</style>


